<div class="loading-container">
    <!-- Loading spinner with conditions to stop spinning and fade-out -->
    <div class="loading-spinner mx-auto" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
    </div>

    <!-- Loading text based on conditions -->
    <ng-container *ngIf="(selectedIndex$ | async) !== 1 && (selectedIndex$ | async) !== 2 && (selectedIndex$ | async) !== 0">
        <p class="loading-text" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
            Classifying project type...</p>
    </ng-container>
    <ng-container *ngIf="(selectedIndex$ | async) === 0">
        <p class="loading-text" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
            Estimating project time...</p>
    </ng-container>
    <ng-container *ngIf="(selectedIndex$ | async) === 1">
        <p class="loading-text" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
            Generating project plan...</p>
    </ng-container>
    <ng-container *ngIf="(selectedIndex$ | async) === 2">
        <p class="loading-text" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
            Generating content...</p>
    </ng-container>
    <p class="loading-text" [ngClass]="{'fade-out': (!(disablePage$ | async) && !(isLoading$ | async))}">
        {{projectHeadline$ | async}}</p>
    <ul [@listAnimation]="(timeSensitiveDetails$ | async).length">
        <li *ngFor="let detail of timeSensitiveDetails$ | async">{{ detail }}</li>
    </ul>
</div>